import { render, staticRenderFns } from "./NewUserSpinStat.vue?vue&type=template&id=e0a1076a&scoped=true&"
import script from "./NewUserSpinStat.vue?vue&type=script&lang=js&"
export * from "./NewUserSpinStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a1076a",
  null
  
)

export default component.exports